const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// Get Billing Address list api
const getBillingAddressApi = async (
    accessToken: string, // access token
): Promise<any> => {
    //get api list

    const url = `${baseURL}/user/address`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// Get country list api
const getCountryListApi = async (
    accessToken: string, // access token
): Promise<any> => {

    const url = `${baseURL}/get-contry`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

const AddBillingAddressApi = async (
  name: any,
  lastName: string,
  streetAddress: string,
  country: string,
  pincode: string,
  vat: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('name', name + ' '+ lastName)
  formData.append('address', streetAddress)
  formData.append('country', country)
  formData.append('pincode', pincode)
  formData.append('address_2', streetAddress)
  formData.append('vat_tax', vat)
  const url = `${baseURL}/user/address`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const UpdateBillingAddressApi = async (
  id:number,
  name: string,
  lastName: string,
  streetAddress: string,
  country: string,
  pincode: string,
  vat: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('name', name + ' '+ lastName)
  formData.append('address', streetAddress)
  formData.append('country', country)
  formData.append('pincode', pincode)
  formData.append('address_2', streetAddress)
  formData.append('vat_tax', vat)
  const url = `${baseURL}/user/address-update/${id}`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const makeDefaultBillingAddressApi = async (
    accessToken: string, // access token
    defaultId: number
): Promise<any> => {
    
  const formData = new FormData();
  const url = `${baseURL}/user/address-default/${defaultId}`
  try {
    // update API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const deleteBillingAddressApi = async (
    accessToken: string, // access token
    defaultId: number
): Promise<any> => {
    
  const formData = new FormData();
  const url = `${baseURL}/user/address/${defaultId}`
  try {
    // delete API
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { getBillingAddressApi, AddBillingAddressApi, makeDefaultBillingAddressApi, deleteBillingAddressApi, getCountryListApi, UpdateBillingAddressApi }